import { ReactNode, useLayoutEffect, useRef } from 'react';
import AlertGroup from '@pelckmans/elementis/components/alert-group';
import CookieAlert from '../../shared-components/CookieAlert';
import OneRosterAdminAlert from '../../shared-components/OneRosterAdminAlert';

/**
 * ContentHeader component for wrapping the content of the header (alerts and cover).
 */
function ContentHeader({ cover }: { cover?: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    function updateContentHeaderHeight() {
      if (ref.current) {
        document.body.style.setProperty('--content-header-height', `${ref.current.clientHeight}px`);
      }
    }

    updateContentHeaderHeight();

    window.addEventListener('resize', updateContentHeaderHeight);

    return () => {
      window.removeEventListener('resize', updateContentHeaderHeight);
    };
  }, []);

  return (
    <div className="content-header" ref={ref}>
      <div className="content-header-alerts">
        <div className="max-container">
          <AlertGroup aria-label={undefined} role="group">
            <CookieAlert />
            <OneRosterAdminAlert />
          </AlertGroup>
        </div>
      </div>
      {cover && cover}
    </div>
  );
}

export default ContentHeader;
